<template>
  <div class="index_bg">
    <div :class="{ 'slide-right': isFadeOut }">
      <div class="top-language">
        <div class="btn-language" :class="{ active: infoLang === 'zh' }" @click="chooseLang('zh')">中</div>
        <div class="btn-language" :class="{ active: infoLang === 'en' }" @click="chooseLang('en')">EN</div>
      </div>
      <div class="title-container">
        <img :src="languageTexts[infoLang].titleURL" alt="">
      </div>
      <div class="start-btn" @click="goNext">
        <span :class="{ en: infoLang === 'en' }">{{ languageTexts[infoLang].btntext }}</span>
        <img src="@/assets/images/button-cover02.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { clearMapHintSeen } from '@/utils/hintFlag'
export default {
  name: 'Language',
  components: {
  },
  data() {
    return {
      isFadeOut: false,
      infoLang: 'zh',
      languageTexts: {
        zh: {
          btntext: '開始體驗',
          titleURL: require('@/assets/images/ar_title.png'),
        },
        en: {
          btntext: 'Start',
          titleURL: require('@/assets/images/ar_title_en.png'),
        }
      }
    }
  },
  mounted() {
    // 回到首頁視為重新開始一次體驗，清掉地圖提示燈箱的已讀紀錄
    clearMapHintSeen()
  },
  methods: {
    chooseLang(lang) {
      // 可根據 lang 設定 cookie 或其他語言邏輯
      Cookies.set('lang', lang)
      this.infoLang = lang
    },
    goNext(){
      this.isFadeOut = true;
      Cookies.set('lang', this.infoLang);
      setTimeout(() => {
        this.$router.push({ name: 'Illustration' })
      }, 500)
    }
  }
}

</script>
<style scoped>
.index_bg {
  background-image: url('@/assets/images/index_bg.jpg');
  background-size: cover;
  background-position: center;
  width: 100vw;
  height: 100vh;
  height: 100svh; /* 使用小視窗高度 */
  min-height: -webkit-fill-available; /* Safari 支援 */
  overflow: hidden;
}

.title-container {
  text-align: center;
  width: 80%;
  margin: auto;
  color: white;
  margin-top: 50vh;
}

.title-container img {
  width: 100%;
}

.top-language {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
}

.btn-language {
  width: 45px;
  height: 45px;
  display: inline-block;
  border: 1px solid white;
  border-radius: 50%;
  margin: 0 10px;
  cursor: pointer;
  user-select: none;
  font-size: 1.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-language.active {
  background-color: rgba(255, 255, 255, 0.7);
  color: rgba(67, 106, 178, 0.8);
}

.slide-right {
  animation: fadeOut 0.5s forwards;
}

.start-btn {
  font-size: 2rem;
  color: white;
  background-color: rgba(153, 153, 153, 0.7);
  width: 62%;
  margin: 4vh auto 0 auto;
  border-radius: 40px;
  border: 1px solid white;
  letter-spacing: 6px;
  padding: 6px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  transition: all 0.3s ease;
  /* 發光效果 */
  box-shadow: 
    0 0 20px rgba(255, 255, 255, 0.3),
    0 0 40px rgba(67, 106, 178, 0.2),
    inset 0 0 20px rgba(255, 255, 255, 0.1);
  
  /* 發光動畫 */
  animation: pulse-glow 2s ease-in-out infinite alternate;
}
.start-btn .en{
  font-size: 1.6rem;
  letter-spacing: 0px;
}
.start-btn img {
  position: absolute;
  left: -5%;
  top: -5%;
  width: 110%;
  z-index: 1000;
  pointer-events: none;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 
      0 0 20px rgba(255, 255, 255, 0.3),
      0 0 40px rgba(67, 106, 178, 0.2);
    transform: scale(1);
  }
  50% {
    box-shadow: 
      0 0 40px rgba(255, 255, 255, 0.7),
      0 0 80px rgba(67, 106, 178, 0.5),
      0 0 120px rgba(67, 106, 178, 0.3);
    transform: scale(1.02);
  }
}

/* Tablet 響應式設計 (iPad Mini - iPad Pro) */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .title-container {
    margin-top: 45vh;
  }
  
  .title-container img {
    width: 80%;
  }
  
  .top-language {
    top: 30px;
    right: 30px;
  }
  
  .btn-language {
    width: 80px;
    height: 80px;
    font-size: 2.5rem;
    margin: 0 15px;
  }
  
  .start-btn {
    font-size: 2.5rem;
    width: 45%;
    margin: 6vh auto 0 auto;
    padding: 12px;
    border-radius: 50px;
    letter-spacing: 8px;
  }
  
  .start-btn .en {
    font-size: 2rem;
    letter-spacing: 2px;
  }
}

/* Large Tablet 響應式設計 (iPad Pro 12.9") */
@media screen and (min-width: 1025px) and (max-width: 1366px) {
  .title-container {
    margin-top: 50vh;
  }
  
  .title-container img {
    width: 70%;
  }
  
  .top-language {
    top: 40px;
    right: 40px;
  }
  
  .btn-language {
    width: 60px;
    height: 60px;
    font-size: 2rem;
    margin: 0 20px;
  }
  
  .start-btn {
    font-size: 3rem;
    width: 35%;
    margin: 8vh auto 0 auto;
    padding: 16px;
    border-radius: 60px;
    letter-spacing: 10px;
  }
  
  .start-btn .en {
    font-size: 2.5rem;
    letter-spacing: 3px;
  }
}

/* Landscape Tablet 響應式設計 */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .title-container {
    width: 45%;
    margin-top: 25vh;
  }
  
  .title-container img {
    width: 80%;
  }
  
  .start-btn {
    font-size: 2.2rem;
    width: 35%;
    margin: 4vh auto 0 auto;
    padding: 10px;
    letter-spacing: 6px;
  }
  
  .start-btn .en {
    font-size: 1.8rem;
    letter-spacing: 1px;
  }
}

</style>
